import Vue from 'vue'

const INSTAGRAM = {
	IMAGE: postShortCode => {
		return Vue.$image_instagram.get('', { params: { postId: postShortCode } })
	},
}

export default INSTAGRAM
